import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CollaborationService } from '../../services/collaboration.service';
import { BasicReusableComponentComponent } from '../basic-reusable-component/basic-reusable-component.component';
import { WeavyData } from '../../interfaces/space.interface';
import { DocumentsComponent } from '../../components/documents/documents.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';

@Component({
    selector: 'app-policy-documents',
    templateUrl: './policy-documents.component.html',
    styleUrl: './policy-documents.component.scss',
    imports: [SpinnerComponent, DocumentsComponent]
})
export class PolicyDocumentsComponent extends BasicReusableComponentComponent {
  @Input() declare weavyData:WeavyData;
  @Output() downloadAdditionalDocs = new EventEmitter<any>();
  @ViewChild('documents') documents!: DocumentsComponent;
  constructor(override collaborationService: CollaborationService) {
    super(collaborationService);
  }

  override initialize(): void {
    this.showLoader = false;
  }

  override refreshWeavy(): void {
    this.documents.handleDocumentRefresh();
  }
}
